import { Component, Input, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

import { Size } from '../../../../_models/size';
import { Template } from '../../../../_models/template';
import { CardService } from '../../card.service';
import { Update } from '../../../../_models/update';

@Component({
  moduleId: module.id,
  selector: 'size-component',
  templateUrl: 'size.component.html',
  styleUrls: ['./size.component.css']
})

export class SizeComponent implements OnInit {
  @Input() size: Size;
  public selected_template_name:string;
  public default_template_name:string;
  public default_template: Template;
  public showFirstSelect = true;
  public showSecondSelect = true;
  broadcast_update: {update: Update, copyToID: string};
  template_names: string[] = [];
  template_names_without_default: string[] = [];
  templates_without_default: Template[] = [];

  constructor(public cardService: CardService, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.loadSize();
  }

  loadSize(update: Update = undefined, newCard: boolean = false) {
    if (update && !newCard) {
      this.showFirstSelect = false;
      this.showSecondSelect = false;
      this.changeDetectorRef.detectChanges();
      this.updateTemplateTitle(update);
    }
    this.template_names = [];
    this.template_names_without_default = [];
    this.templates_without_default = [];

    for (let template of this.size.cards) {
      this.template_names.push(template.name);
    }

    this.default_template = this.getDefaultTemplate();
    this.default_template_name = this.default_template.name;

    // If we have more than 1 template, add all non-default templates to a special array
    if (this.size.cards.length > 1) {
      for (let template of this.size.cards) {
        if (template.name !== this.default_template.name) {
          this.template_names_without_default.push(template.name);
          this.templates_without_default.push(template);
        }
      }
    }
    this.selected_template_name = this.getSelectedTemplateName(update, newCard);
    if (update && !newCard) {
    }

    if (update && !newCard) {
      this.showFirstSelect = true;
      this.showSecondSelect = true;
      this.changeDetectorRef.detectChanges();
    }
  }

  getDefaultTemplate() {
    // The default template is always the first template, order is determined in the backend
    if (this.size.cards.length > 0) {
      return this.size.cards[0];
    }
    else {
      return undefined;
    }
  }

  getSelectedTemplateName(update, newCard) {
    if (this.size.cards.length > 1) {
      if (update && update.name && this.default_template.name != update.name) {
        return update.name;
      } else {
        return this.template_names_without_default[0];
      }
    } else {
      return undefined;
    }
  }



  updateTemplateTitle(update: Update) {
    // Update the name of the template
    if (update.name) {
      const templateID = update.template_id;
      // Template_id is not unique, so also make sure that the old_name equals card.name
      const card = this.size.cards.filter(card => card.template_id === templateID && card.name === update.old_name);
      if (this.selected_template_name == card[0].name) { this.selected_template_name = update.name }
      card[0].name = update.name;
    }
  }

  setTemplate(template_name:string) {
    this.selected_template_name = template_name;
  }

  getSelectedTemplate():Template {
    for (let template of this.size.cards) {
      if (template.name === this.selected_template_name) {
        return template;
      }
    }
    return null;
  }

  sendUpdates(update_to_be_broadcasted:{update:Update, copyToID: string}) {
    this.broadcast_update = update_to_be_broadcasted;
  }
}




// WEBPACK FOOTER //
// /app/src/app/hq/cards/view-cards/grouped-by-size/size.component.ts